import { GetAirportZipCodeState } from './getAirportZipCode.types'

const initialState: GetAirportZipCodeState = {
  loading: false,
  error: null,
  success: null
}

export default initialState
